import { jsx as _jsx } from "react/jsx-runtime";
import { PluginSourceLabel } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/plugins/PluginSourceLabel.js';
import { PLUGIN_ICON } from '#pplx/frontend/apps/ask/skills/utils/getMenuIcon.js';
export function pluginToMenuItem(plugin) {
    return {
        type: 'plugin',
        id: `plugin-${plugin.id}`,
        title: plugin.title,
        description: plugin.description,
        icon: PLUGIN_ICON,
        isNew: false,
        sourceLabel: _jsx(PluginSourceLabel, { plugin: plugin }),
        heroImageUrl: null,
        action: {
            type: 'plugin',
            plugin,
        },
    };
}
//# sourceMappingURL=pluginToMenuItem.js.map